<div class="configurationBannerHeader" (click)="toggleExpansion()">
  <label class="configurationBannerLabel">Mechanical Options</label>
  <span class="spacer"></span>
  <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
</div>
@if (!collapsed) {
  <div class="selectionsWrapper">
    <div class="configurationDetailRow">
      <div class="fullWidthConfigurationInput">
        <div class="modConnectionRow">
          @if (returnLocationSelection) {
            <span>
              <label class="modConnectionLabel">Return Location:</label>
              <select class="modConnectionField" #returnLocationInput
                [class.invalidConfigurationSelection]="isInvalidSelection(returnLocationSelection.Name)"
                (change)="selectedValueChanged(returnLocationSelection.Name, returnLocationInput.value)"
                [value]="returnLocationSelection.Value.toString()">
                @for (allowable of returnLocationSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="returnLocationSelection.Value && returnLocationSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="modConnectionRow">
          @if (frontSupplySelection) {
            <span>
              <label [class.invalidConfigurationSelection]="isInvalidSelection(frontSupplySelection.Name)"
              for="frontSupplyInput" class="modConnectionLabel">Front Supply:</label>
              <input type="checkbox" class="checkboxInput" id="frontSupplyInput"
                #frontSupplyInput [checked]="'true' === frontSupplySelection.Value"
                (change)="selectedValueChanged(frontSupplySelection.Name, frontSupplyInput.checked.toString())">
            </span>
          }
          @if (topSupplySelection) {
            <span>
              <label [class.invalidConfigurationSelection]="isInvalidSelection(topSupplySelection.Name)"
              for="topSupplyInput" class="modConnectionCheckboxLabel">Top Supply:</label>
              <input type="checkbox" class="checkboxInput" id="topSupplyInput"
                #topSupplyInput [checked]="'true' === topSupplySelection.Value"
                (change)="selectedValueChanged(topSupplySelection.Name, topSupplyInput.checked.toString())">
            </span>
          }
        </div>
        <div class="modConnectionRow">
          @if (leftSupplySelection) {
            <span>
              <label [class.invalidConfigurationSelection]="isInvalidSelection(leftSupplySelection.Name)"
              for="leftSupplyInput" class="halfWidthInputLabel">Left Supply:</label>
              <input type="checkbox" class="checkboxInput" id="leftSupplyInput"
                #leftSupplyInput [checked]="'true' === leftSupplySelection.Value"
                (change)="selectedValueChanged(leftSupplySelection.Name, leftSupplyInput.checked.toString())">
            </span>
          }
          @if (rightSupplySelection) {
            <span>
              <label [class.invalidConfigurationSelection]="isInvalidSelection(rightSupplySelection.Name)"
              for="rightSupplyInput" class="modConnectionCheckboxLabel">Right Supply:</label>
              <input type="checkbox" class="checkboxInput" id="rightSupplyInput"
                #rightSupplyInput [checked]="'true' === rightSupplySelection.Value"
                (change)="selectedValueChanged(rightSupplySelection.Name, rightSupplyInput.checked.toString())">
            </span>
          }
        </div>
        <div class="modConnectionRow">
          @if (riserConnectionSelection) {
            <span>
              <label class="halfWidthInputLabel">Riser Connection:</label>
              <select class="halfWidthInputField" #riserConnectionInput
                [class.invalidConfigurationSelection]="isInvalidSelection(riserConnectionSelection.Name)"
                (change)="selectedValueChanged(riserConnectionSelection.Name, riserConnectionInput.value)"
                [value]="riserConnectionSelection.Value.toString()">
                @for (allowable of riserConnectionSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="riserConnectionSelection.Value && riserConnectionSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="modConnectionRow">
          @if (riserFlowSelection) {
            <span>
              <label class="halfWidthInputLabel">Riser Flow:</label>
              <select class="halfWidthInputField" #riserFlowInput
                [class.invalidConfigurationSelection]="isInvalidSelection(riserFlowSelection.Name)"
                (change)="selectedValueChanged(riserFlowSelection.Name, riserFlowInput.value)"
                [value]="riserFlowSelection.Value.toString()">
                @for (allowable of riserFlowSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="riserFlowSelection.Value && riserFlowSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="modConnectionRow">
          @if (returnAirSelection) {
            <span>
              <label class="halfWidthInputLabel">Return Air Style:</label>
              <select class="halfWidthInputField" #returnStyleInput
                [class.invalidConfigurationSelection]="isInvalidSelection(returnAirSelection.Name)"
                (change)="selectedValueChanged(returnAirSelection.Name, returnStyleInput.value)"
                [value]="returnAirSelection.Value.toString()">
                @for (allowable of returnAirSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="returnAirSelection.Value && returnAirSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="modConnectionRow">
          @if (supplyAirSelection) {
            <span>
              <label class="halfWidthInputLabel">Supply Air Type:</label>
              <select class="halfWidthInputField" #supplyTypeInput
                [class.invalidConfigurationSelection]="isInvalidSelection(supplyAirSelection.Name)"
                (change)="selectedValueChanged(supplyAirSelection.Name, supplyTypeInput.value)"
                [value]="supplyAirSelection.Value.toString()">
                @for (allowable of supplyAirSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="supplyAirSelection.Value && supplyAirSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="modConnectionRow">
          @if (opposedBladeDamperSelection) {
            <span>
              <label [class.invalidConfigurationSelection]="isInvalidSelection(opposedBladeDamperSelection.Name)"
              for="opposedBladeDamperInput" class="halfWidthInputLabel">Opposed Blade Damper:</label>
              <input type="checkbox" class="checkboxInput" id="opposedBladeDamperInput"
                #opposedBladeDamperInput [checked]="'true' === opposedBladeDamperSelection.Value"
                (change)="selectedValueChanged(opposedBladeDamperSelection.Name, opposedBladeDamperInput.checked.toString())">
            </span>
          }
        </div>
        <div class="modConnectionRow">
          @if (outsideAirSelection) {
            <span>
              <label class="halfWidthInputLabel">Outside Air:</label>
              <select class="halfWidthInputField" #outsideAirInput
                [class.invalidConfigurationSelection]="isInvalidSelection(outsideAirSelection.Name)"
                (change)="selectedValueChanged(outsideAirSelection.Name, outsideAirInput.value)"
                [value]="outsideAirSelection.Value.toString()">
                @for (allowable of outsideAirSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="outsideAirSelection.Value && outsideAirSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="modConnectionRow">
          @if (outsideAirLocationSelection) {
            <span>
              <label class="halfWidthInputLabel">Outside Air Location:</label>
              <select class="halfWidthInputField" #outsideAirLocationInput
                [class.invalidConfigurationSelection]="isInvalidSelection(outsideAirLocationSelection.Name)"
                (change)="selectedValueChanged(outsideAirLocationSelection.Name, outsideAirLocationInput.value)"
                [value]="outsideAirLocationSelection.Value.toString()">
                @for (allowable of outsideAirLocationSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="outsideAirLocationSelection.Value && outsideAirLocationSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="modConnectionRow">
          @if (paintOptionsSelection) {
            <span>
              <label class="halfWidthInputLabel">Paint Options:</label>
              <select class="halfWidthInputField" #paintOptionsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(paintOptionsSelection.Name)"
                (change)="selectedValueChanged(paintOptionsSelection.Name, paintOptionsInput.value)"
                [value]="paintOptionsSelection.Value.toString()">
                @for (allowable of paintOptionsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="paintOptionsSelection.Value && paintOptionsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
      </div>
      <div class="fullWidthConfigurationInput">
        @if (pipeDetailImagePath() && pipeDetailImagePath().length > 0) {
          <img class="detailImage"
            [src]="pipeDetailImagePath()" alt="PipeDetailImage"/>
        }
        @if (handArrangementImagePath() && handArrangementImagePath().length > 0) {
          <img class="detailImage"
            [src]="handArrangementImagePath()" alt="ArrangementImage"/>
        }
      </div>
    </div>
  </div>
}
